import {
    Button,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
  } from "@mui/material";
  import _ from "lodash";
  import React from "react";
import { useStyle } from "./style";
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from "react-router-dom";
  const OtToOtTransferTable = ({tableHeadData , tableBodyData,setOpen,data}) => {
    console.log(data)
 const classes = useStyle()
 const location = useLocation()
 const currentPath = location.pathname;
 console.log(tableBodyData)
    return ( 
      <Grid sx={{ backgroundColor: "#fff",padding:"10px",maxHeight:"500px" ,overflowY:"auto"}}>
        <div className="flex justify-between">
          {data && 
          <Grid className="flex my-1" style={{flexDirection:"column"}}>
           <Typography >Outlet : <strong>{data.otCode}</strong> - <strong>{data.party}</strong> </Typography>
           {/* <Typography >Sales Man : <strong>{data.salesManCode}</strong> - <strong>{data.salesManName}</strong> </Typography> */}
            <Typography>Bill Date : <strong>{data.documentDate}</strong></Typography>
          </Grid>
          }
          {/* {currentPath == "/reports/outletSalesReport" && data &&
          <>
            <div className="flex my-1" style={{flexDirection:"column"}}>
            <Typography >Sales Man : <strong>{data.salesManCode}</strong> - <strong>{data.salesManName}</strong> </Typography>
             <Typography>Payment Mode : <strong>{data.mode}</strong></Typography>
          </div>
          </>
          } */}
          <IconButton size="small" sx={{marginBlockEnd:2,}} onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </div>
        <TableContainer className={classes.tblRoot} >
          <Table className={classes.table}>
            <TableHead className={classes.tblHeader} sx={{backgroundColor:"#A06EE1",color:"#fff"}}>
              <TableRow className={classes.tablrow} sx={{color:"#fff"}}>
                {tableHeadData.map((item) => (
                  <TableCell className={classes.tblCell} sx={{color:"#fff"}} key={item.id}>{item.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
            {tableBodyData.map((val) => (
              <>
                <TableRow className={classes.tablrow}  key={val.id}>
                    <TableCell sx={{borderLeft:"1px solid #ccc !important"}}>{val.sNo}</TableCell>
                    <TableCell sx={{borderLeft:"1px solid #ccc !important"}}>{val.date}</TableCell>
                    <TableCell sx={{borderLeft:"1px solid #ccc !important"}}>{val.denomination}</TableCell>
                    <TableCell  sx={{borderLeft:"1px solid #ccc !important"}}>{val.proName}</TableCell>
                    <TableCell sx={{borderLeft:"1px solid #ccc !important"}}>{val.count}</TableCell>
                    <TableCell sx={{borderLeft:"1px solid #ccc !important",fontWeight:600,textAlign:"right !important"}}>{val.total}</TableCell>
                </TableRow>
              </>
            ))}
            </TableBody>
          </Table>
        </TableContainer>
        {data && <Typography sx={{textAlign:"end",padding:1}}>Total Amount : <strong>{parseFloat(data.tot).toFixed(0)}</strong></Typography>}
      </Grid>
    );
  };
  
  export default OtToOtTransferTable;